import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Transition from '../../../../components/Transition';
import { useAppContext } from '../../../../context/AppContext';
import Error from '../../../error';
import { ArticleData } from '../../network/api/ArticleData';
import { AnimatePresence } from 'framer-motion';

export default function DetailPage({slugI = null}) {
    const { appData } = useAppContext();
    let { slug } = useParams();
    const navigate = useNavigate();
    const [info, setInfo] = useState(null);
    const [error, setError] = useState(null);

    slug = slugI ? slugI : slug;

    useEffect(() => {
        async function fetchArticle() {
            try {
                const response = await ArticleData(appData.id, slug);
                if (response.status === "success") {
                    setInfo(response.data);
                } else {
                    setError({ code: response.code || 500, message: response.message || "Failed to load article." });
                }
            } catch (err) {
                setError({ code: 500, message: "Something went wrong while fetching the article." });
            }
        }

        fetchArticle();
    }, [appData.id, slug]);

    if (error) {

        return (
            <div className="authincation h-100">
                <Error code={error.code} message={error.message} />
            </div>

        );
    }
    return (
        <AnimatePresence mode="wait">
            <Transition key={"article-detail-page"}>

                <div className="container-fluid ">
                    <div className="row">

                        <div className="col-12">
                            <div className="justify-content-between align-items-center ">

                                {info && (
                                    <>
                                        <div className="d-flex justify-content-center">
                                            <div className="col-lg-8 col-12">
                                                <main className="card custom-card flex-grow-1">
                                                    <div className="card-header">
                                                        <h1 className="card-title display-5 fw-bold">{info.title}</h1>

                                                        <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate(-1)}>
                                                            ← Back
                                                        </button>

                                                    </div>
                                                    <div className="card-body" >

                                                        <>
                                                            <style>{`
                                                            .article-content img {
                                                                max-width: 100%;
                                                                height: auto;
                                                                display: block;
                                                                margin: 1rem auto;
                                                                border-radius: 0.5rem;
                                                            }
                                                        `}</style>
                                                            <div className="article-content" dangerouslySetInnerHTML={{ __html: info.content }} />
                                                        </>

                                                    </div>
                                                </main>

                                                <footer className=" border-top text-center">
                                                    <div className="">
                                                        <small >
                                                            &copy; {new Date().getFullYear()} {info.title} · {appData?.name}. All rights reserved. <br />
                                                        </small>
                                                    </div>
                                                </footer>
                                            </div>
                                        </div>
                                    </>
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </Transition>
        </AnimatePresence>
    );
}